import React from 'react';
import useReveal from '../hooks/useReveal';

const Reveal = ({ children, className = '', delay = 0, as: Tag = 'div' }) => {
  const [ref, inView] = useReveal();
  return (
    <Tag
      ref={ref}
      className={`reveal ${inView ? 'in' : ''} ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
